import { Modification, ModificationHandler, ModificationAction } from '@core/types';
import { ModificationError } from '@shared/errors';

export class VisibilityModificationHandler implements ModificationHandler {
  apply(element: Element, modification: Modification): void {
    const htmlElement = element as HTMLElement;

    switch (modification.action) {
      case ModificationAction.HIDE:
        if (!htmlElement.dataset._origDisplay) {
          htmlElement.dataset._origDisplay = htmlElement.style.display || '';
        }
        htmlElement.style.display = 'none';
        break;

      default:
        throw new ModificationError(
          `Unsupported visibility action: ${modification.action}`,
          modification.action,
        );
    }
  }

  validate(modification: Modification): boolean {
    return modification.action === ModificationAction.HIDE;
  }

  remove(element: Element): void {
    const htmlElement = element as HTMLElement;

    if (htmlElement.dataset._origDisplay !== undefined) {
      htmlElement.style.display = htmlElement.dataset._origDisplay;
      delete htmlElement.dataset._origDisplay;
    }
  }
}
